import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate"; // 引入插件
import user from "./modules/user";
import companyInfo from "./modules/companyInfo";
import search from "./modules/search";
import theme from "./modules/theme";
import goods from "./modules/goods";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 表格分页
    table: {
      pageSize: 20,
      pageSizeList: [10, 20, 50, 100, 200],
      layout: "total, sizes, prev, pager, next, jumper"
    },
    // 服务协议
    user_service_agreement: "https://dl.threesoft.cn/user_service_agreement.html",
    // 隐私政策
    privacy_policy: "https://dl.threesoft.cn/user_service_agreement.html",
    // 请求失败类型 保证事件只执行一次
    requestErrType: ""
  },
  mutations: {
    changeTablePageSize(state, data) {
      state.table.pageSize = data;
    }
  },
  actions: {},
  modules: {
    user,
    companyInfo,
    search,
    theme,
    goods
  },
  plugins: [
    // 配置 vuex-persistedstate 插件
    createPersistedState({
      paths: ["search"], // 指定只持久化 search 模块的状态
      storage: window.sessionStorage, // 改用 sessionStorage，页面关闭后数据清除
      key: "product-search" // 自定义存储的键名
    }),
    createPersistedState({
      paths: ["goods"],
      storage: window.sessionStorage,
      key: "goods-key"
    })
  ]
});
